// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GOnb","toggle":"styles_toggle__3zx8y","preview":"styles_preview__1FuFE"};